/**
 * ViewError.tsx - Error state component for views
 */

import React from 'react';

export interface ViewErrorProps {
  error: string;
  details?: string;
}

export const ViewError: React.FC<ViewErrorProps> = ({ error, details }) => {
  return (
    <div className="view-error" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      minHeight: '200px',
      backgroundColor: '#fff3cd',
      border: '1px solid #ffc107',
      borderRadius: '4px',
    }}>
      <div style={{
        fontSize: '48px',
        marginBottom: '1rem',
      }}>⚠️</div>
      <h3 style={{
        margin: '0 0 0.5rem 0',
        color: '#856404',
      }}>{error}</h3>
      {details && (
        <p style={{
          margin: 0,
          color: '#856404',
          fontSize: '0.9rem',
        }}>{details}</p>
      )}
    </div>
  );
};
